<ng-template #vbTooltipContent>
	<section class="contentWrapper">
		<p>{{ text }}</p>
		<p [hidden]="!linkUrl">{{ 'Tooltip_LearnMore' | translate }} <a href="{{ linkUrl }}" class="contentLink">{{ 'UI_HereLink' | translate }}</a></p>
	</section>
</ng-template>

<span class="vb-tooltip-icon glyphicons" [class]="iconName" [tooltip]="vbTooltipContent" [attr.aria-label]="text" #popup="bs-tooltip" container="body" tabindex="0" [placement]="placement" [triggers]="tooltipTrigger">
</span>
